import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter, } from 'react-router-dom'
import firebase from './firebase'
import '../Sidebar.css'
import Navigations from './navbarAdmin'
import { update_user, remove_user, onOpen } from '../store/actions/actions';
import '../screens/Admin/styles.css'
// import './scripts'
class Books extends Component {
    constructor(props) {
        super(props);

        this.state = {
            blogs: [],
            books: [],
            downloads: []

        };


    }

    componentDidMount() {
        // this.blogData()
        this.authListener();
    }

    blogData = () => {
        this.firebaseRef = firebase.database().ref("BlogData");
        this.firebaseRef.on('value', (snapshot) => {
            let message = snapshot.val();
            // console.log(message)
            var newArr = []
            for (let word in message) {
                // console.log(message[word].pushKey);
                newArr.push({
                    createAt: message[word].createAt,
                    newPostKey: message[word].newPostKey,
                    heading: message[word].heading,
                    description: message[word].description,
                    downloadURL: message[word].downloadURL,
                });
            }
            // console.log(message);
            // // arr.push(message)
            this.setState({ blogs: newArr });
        }
        )
    }

    authListener() {
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                // console.log("user changed..", user.email);
                this.setState({
                    uid: user.uid,
                    displayEmail: user.email
                });
            } else {
                // No user is signed in.
                // browserHistory.push("/signin");
            }
        });
    }


    render() {
        // sb-sidenav-toggled
        return (
            <div>

                <Navigations />
                <div id="layoutSidenav" >
                    <div id="layoutSidenav_nav" >
                        <nav class=" sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                            <div class="sb-sidenav-menu" >
                                <div class="nav">
                                    {/* <div class="sb-sidenav-menu-heading">Core</div> */}
                                    <a class="nav-link" href="/admin"
                                    ><div class="sb-nav-link-icon"><i class="fas fa-tachometer-alt"></i></div>
                                        Dashboard</a>

                                    <a class="nav-link" href="/AddBlogs" >
                                        <div class="sb-nav-link-icon">
                                            <i class="fas fa-chart-area"></i>
                                        </div>  Add Blogs</a>
                                    <a class="nav-link" href="/addDownloads">
                                        <div class="sb-nav-link-icon">
                                            <i class="fas fa-table"></i>
                                        </div> Add Downloads</a>
                                    <a class="nav-link" href="/addbooks">
                                        <div class="sb-nav-link-icon">
                                            <i class="fas fa-chart-area"></i>
                                        </div>  Add Books</a>
                                    <a class="nav-link" href="/addProjects">
                                        <div class="sb-nav-link-icon">
                                            <i class="fas fa-table"></i>
                                        </div> Add Projects</a>

                                </div>
                            </div>
                            <div class="sb-sidenav-footer">
                                <div class="small">Logged in as:</div>
                                {this.state.displayEmail}
                            </div>
                        </nav>
                    </div>
                </div>
            </div >
        )
    }
}


// export default Books 
const mapStateToProps = state => {
    // console.log(state.dw)
    return {
        user: state.user,
        dwOpen: state.dw
    }
}


const mapDispatchToProps = dispatch => {
    return {
        store_user: (user) => dispatch(update_user(user)),
        logout_user: () => dispatch(remove_user()),
        onToggle: (user) => dispatch(onOpen(user)),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Books));
